export default __webpack_public_path__ + "static/media/person-3-safari-14.f2716c57.png";